<script>
export default {
  name: 'NonDynamicTransportNotificationRow',
  props: {
    notification: {
      type: Number,
      default: null,
    },
    index: {
      type: Number,
      default: null,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<template>
  <v-layout column>
    <v-layout row class="pa-3 mt-4">
      <v-flex>
        <v-text-field
          :label="$t('nonDynamicTransport.labels.notification')"
          solo
          disabled
        />
      </v-flex>
      <v-flex class="ml-2 xs12 sm5 md3">
        <v-text-field
          :value="notification"
          :label="$t('nonDynamicTransport.labels.days')"
          :disabled="readOnly"
          solo
          @input="$emit('input', { index, value: +$event })"
        />
      </v-flex>
      <v-flex>
        <v-icon
          class="mt-2 ml-2"
          color="red"
          :disabled="readOnly"
          @click="$emit('remove', index)"
        >
          delete
        </v-icon>
      </v-flex>
    </v-layout>
    <v-divider class="mr-3 ml-3"/>
  </v-layout>
</template>

<style scoped lang="scss">
  /deep/ .v-text-field .v-label {
    font-size: 15px;
  }

  /deep/ .v-text-field {
    font-size: 15px;
  }
</style>



// WEBPACK FOOTER //
// src/components/non-dynamic-transport/NonDynamicTransportNotificationRow.vue